<template>
    <Avatar
        v-b-tooltip.hover 
        :title="user.name" 
        :src="user.picture" 
        :username="user.name" 
        :size="35" 
        class="mr-3" 
    />
</template>

<script>
import Avatar from 'vue-avatar'

export default {
    name: 'UserPicture',
    components: {
        Avatar,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
    },
}
</script>
